export const maqueta = {
    text1: "Es wurden durchgeführt",
    text2: "Check-ins",
    text3: "Eingesparte Blätter Papier 😊",
    text4: "Alle 100 Check-ins pflanzen wir einen Baum mit",
    text5: "ONE TREE PLANTED",
    text6: "Benachrichtigungen",
    text7: "Sie haben keine Benachrichtigungen",
    text8: "Alle ansehen",
    text9: "Willkommen",
    text10: "Unternehmen",
    text11: "Alle Unterkünfte",
    text12: "Profil",
    text13: "Abmelden",
    text14: "Beim Abmelden ist leider ein Fehler aufgetreten",
    text15: "Die Zahlung Ihres Abonnements wurde abgelehnt",
    text16: "Um WACheckin weiter zu nutzen, müssen Sie Ihre Zahlung abschließen",
    text17: "Check-in-Informationen",
    text18: "Check-in-Daten",
    text19: "Anfragedatum:",
    text20: " um",
    text21: "Beim Check-in des Gastes erfasste Daten",
    text22: "Vorname",
    text23: "Nachname",
    text24: "Telefon",
    text25: "Aufenthaltsdatum",
    text26: "Dokumenttyp",
    text27: "Reisepass",
    text28: "Personalausweis",
    text29: "Dokumentnummer",
    text30: "Zusätzliche Informationen",
    text31: "Ablauf des Dokuments",
    text32: "Nationalität",
    text33: "Geburtsdatum",
    text34: "Geschlecht",
    text35: "Weiblich",
    text36: "Männlich",
    text37: "Schließen",
    text38: "Check-ins",
    text39: "Serviceanfragen",
    text40: "Unterkünfte",
    text41: "Cross-Selling",
    text42: "Integrationen",
    text43: "Abrechnung",

    // Corrections
    p1: "Buchungen",

    // Plan validation corrections
    p2: `Upgraden Sie Ihren Tarif, um Check-ins durchzuführen`,
    p3: `Leider haben Sie derzeit kein aktives Abonnement und kein Guthaben für Ihre Unterkunft.`,
    p4: `Tarif upgraden`,

    p5: `Check-ins sind in dieser Unterkunft nicht verfügbar.`,
    p6: `Weitere Informationen erhalten Sie beim Eigentümer der Unterkunft.`,

    p7: `Konto nicht bestätigt`,
    p8: `Bitte prüfen Sie Ihren Posteingang und bestätigen Sie Ihr Konto. Keine E-Mail erhalten?`,
    p9: `Erneut senden`,
    p10: `E-Mail wird gesendet, bitte warten...`,
    p11: `Mein Abonnement`,

    p12: `Sprache und Region`,
    p13: `Wählen Sie eine Sprache und eine Region`,
    p14: `Hier sehen Sie alle abgeschlossenen Check-ins.`,
    p15: `Planen Sie Ihre Check-ins im Voraus und senden Sie sie an Ihre Gäste.`,
    p16: `Hier finden Sie Serviceanfragen Ihrer Gäste, etwa Mietangebote, Touren und mehr.`,
    p17: `WhatsApp-Massenversand`,
    p18: `Verbinden Sie Ihr WhatsApp Business-Konto mit unserer Plattform und aktivieren Sie den Massenversand personalisierter Nachrichten an Ihre Gäste, schnell und einfach, direkt von Ihrer offiziellen Nummer aus.`,
    p19: `Diese Funktion befindet sich noch in Entwicklung.`,
    p20: `Check-in-Informationen`,

    p21: `Check-in-Informationen`,
    p22: `Zugehörige Check-ins`,
    p23: `Keine zugehörigen Check-ins.`,
    p24: `Weitere Informationen:`,
    p25: `Welche Unterkunft möchten Sie verwalten?`,
    p26: ``,
    p27: ``,
    p28: ``,
    p29: ``,
    p30: ``,
    p31: ``,
};
